async function get_s3_bucket_objects_list(){
  // const BASE_URL = 'http://127.0.0.1:5000/list_s3_objects?'
  const BASE_URL = 'https://zoabdrjitpu23ilf6q3efgjiue0xpuhq.lambda-url.us-east-1.on.aws/list_s3_objects?'

    const bucketName = 'smartapps-gbm-dev'
    const directory_prefix = '/python-input'
    let ar =[]

    const url = BASE_URL + new URLSearchParams({bucketName: bucketName, directoryPrefix: directory_prefix})
    try{
      let data = await fetch(url, {
                    method: 'get',
       })
       .then(res => res.json())
     //  .then(json => json.Contents.map(x => x['Key'].replace('python-input/', '')))

       data['Contents'].sort(compare)
       return data

       function compare(a, b){
         if(new Date(a['LastModified']) > new Date(b['LastModified'])){
           return -1;
         }
         else{
           return 1;
         }

       }
    }
    catch(error){
       console.error(error)
    }
}

export {get_s3_bucket_objects_list}